import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule} from 'ionic-angular';

//Componentes y Providers
// import { OneSignal } from '@ionic-native/onesignal';
import { StatusBar } from '@ionic-native/status-bar';
import { HttpProvider } from '../providers/http/http';
import { HttpClientModule } from '@angular/common/http';
import { Geolocation } from '@ionic-native/geolocation';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Stripe } from '@ionic-native/stripe';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { Camera } from '@ionic-native/camera';
import { NativeAudio } from '@ionic-native/native-audio'
import { DocumentViewer } from '@ionic-native/document-viewer';
import { File } from '@ionic-native/file';
import { FileOpener } from '@ionic-native/file-opener';
import { SocialSharing } from '@ionic-native/social-sharing';
import { Network } from '@ionic-native/network'
import { IonicImageLoader } from 'ionic-image-loader';
import { ImagePicker } from '@ionic-native/image-picker';
import { FileTransfer } from '@ionic-native/file-transfer';
import { FileChooser } from '@ionic-native/file-chooser';
import {BluetoothSerial} from '@ionic-native/bluetooth-serial';

//Pantallas
import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { FacturaPage } from '../pages/factura/factura';
import { PedidoPage } from '../pages/pedido/pedido';
import { InicioPage } from '../pages/inicio/inicio';
import { LoginPage } from '../pages/login/login';
import { MonedaPage } from '../pages/moneda/moneda';
import { OrdenesPage } from '../pages/ordenes/ordenes';
import { PagoPage } from '../pages/pago/pago';
import { OrdenPage } from '../pages/orden/orden';
import { CargandoPage } from '../pages/cargando/cargando';
import { DetallePage } from '../pages/detalle/detalle';
import { BusquedaPage } from '../pages/busqueda/busqueda';
import { ProductoPage } from '../pages/producto/producto';
import { FacturasPage } from '../pages/facturas/facturas';
import { PedidosPage } from '../pages/pedidos/pedidos';
import { ClientesPage } from '../pages/clientes/clientes';
import { ClientePage } from '../pages/cliente/ciente';
import { DashboardPage } from '../pages/dashboard/dashboard';
import { ExitoPage } from '../pages/exito/exito';
import { VendedoresPage } from '../pages/vendedores/vendedores';
import { ProvidersFormatoPipe } from '../pipes/providers-formato/providers-formato';
import { Detalle2Page } from '../pages/detalle2/detalle2';
import { TabsPage } from '../pages/tabs/tabs';
import { EsperaPage } from '../pages/espera/espera';
import { ReportesPage } from '../pages/reportes/reportes';
import { ReportePedidosPage } from '../pages/reporte-pedidos/reporte-pedidos';
import { ReporteClientesInactivosPage } from '../pages/reporte-clientes-inactivos/reporte-clientes-inactivos';
import { ReportePagosPage } from '../pages/reporte-pagos/reporte-pagos';
import { FinishPage } from '../pages/finish/finish';
import { DetailPage } from '../pages/detail/detail';
import { CobrosPage } from '../pages/cobros/cobros';
import { CobroPage } from '../pages/cobro/cobro';
import { TextMaskModule } from 'angular2-text-mask';
import { IonicSelectableModule } from 'ionic-selectable';
import { SolicitudPage } from '../pages/solicitud/solicitud';
import { SolicitudesPage } from '../pages/solicitudes/solicitudes';
import { ImagenPage } from '../pages/imagen/imagen';
import { Tabs2Page } from '../pages/tabs2/tabs2';
import { DevolucionesPage } from '../pages/devoluciones/devoluciones';
import { DevolucionPage } from '../pages/devolucion/devolucion';
import { ProyeccionesPage } from '../pages/proyecciones/proyecciones';
import { CrearProyeccionPage } from '../pages/crear-proyeccion/crear-proyeccion';
import { ResumenPage } from '../pages/resumen/resumen';
import { CxcPage } from '../pages/cxc/cxc';
import { MapaPage } from '../pages/mapa/mapa';
import { ReporteResumenPage } from '../pages/reporte-resumen/reporte-resumen';
import { FiltroAlmacenPage } from '../pages/filtro-almacen/filtro-almacen';


@NgModule({
  declarations: [
    MyApp,
    HomePage,
    InicioPage,
    FacturaPage,
    PedidoPage,
    LoginPage,
    MonedaPage,
    OrdenesPage,
    PagoPage,
    OrdenPage,
    CargandoPage,
    DetallePage,
    BusquedaPage,
    ProductoPage,
    FacturasPage,
    PedidosPage,
    ClientesPage,
    ClientePage,
    DashboardPage,
    ExitoPage,
    VendedoresPage,
    ProvidersFormatoPipe,
    Detalle2Page,
    TabsPage,
    EsperaPage,
    ReportesPage,
    ReportePedidosPage,
    ReporteClientesInactivosPage,
    ReportePagosPage,
    FinishPage,
    DetailPage,
    CobrosPage,
    CobroPage,
    SolicitudPage,
    SolicitudesPage,
    ImagenPage,
    Tabs2Page,
    DevolucionesPage,
    DevolucionPage,
    ProyeccionesPage,
    CrearProyeccionPage,
    ResumenPage,
    CxcPage,
    MapaPage,
    ReporteResumenPage,
    FiltroAlmacenPage
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp),
    HttpClientModule,
    BrowserAnimationsModule,
    IonicImageLoader.forRoot(),
    TextMaskModule,
    IonicSelectableModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    InicioPage,
    FacturaPage,
    PedidoPage,
    LoginPage,
    MonedaPage,
    OrdenesPage,
    PagoPage,
    OrdenPage,
    CargandoPage,
    DetallePage,
    BusquedaPage,
    ProductoPage,
    FacturasPage,
    PedidosPage,
    ClientesPage,
    ClientePage,
    DashboardPage,
    ExitoPage,
    VendedoresPage,
    Detalle2Page,
    TabsPage,
    EsperaPage,
    ReportesPage,
    ReportePedidosPage,
    ReporteClientesInactivosPage,
    ReportePagosPage,
    FinishPage,
    DetailPage,
    CobrosPage,
    CobroPage,
    SolicitudPage,
    SolicitudesPage,
    ImagenPage,
    Tabs2Page,
    DevolucionesPage,
    DevolucionPage,
    ProyeccionesPage,
    CrearProyeccionPage,
    ResumenPage,
    CxcPage,
    MapaPage,
    ReporteResumenPage,
    FiltroAlmacenPage
  ],
  providers: [
    // OneSignal,
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    HttpProvider,
    Stripe,
    BarcodeScanner,
    Camera,
    FileTransfer,
    NativeAudio,
    SocialSharing,
    Network,
    File,
    Geolocation,
    FileOpener,
    DocumentViewer,
    InAppBrowser,
    ImagePicker,
    FileChooser,
    BluetoothSerial
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts